import { apiService } from "./ApiService";

export const setAndroidToken = (deviceId: string) => {
  return apiService.put<unknown>({
    path: `v1/account/device`,
    body: { audid: deviceId },
  });
};
